import {defineMessages} from "react-intl";

/**
 * These are error messages that can be returned by the backend.
 *
 * The keys are the error types returned by the backend, the values are
 * the corresponding messages.
 *
 * TODO: we should generate a list of possible error types from the backend and use it here.
 * The generated list could be a GraphQL enum. Some of these come from Pydantic, others are custom.
 */
const errorMessages = defineMessages({
    "value_error.auto_increment_requires_cc_base": {
        id: "value_error.auto_increment_requires_cc_base",
        defaultMessage: "Call Center must be enabled in the domain.",
    },
    "value_error.sny_str.min_length": {
        id: "value_error.any_str.min_length",
        defaultMessage:
            "Must be at least {limit_value, number} {limit_value, plural, one {character} other {characters}}",
    },
    "value_error.any_str.max_length": {
        id: "value_error.any_str.max_length",
        defaultMessage:
            "Must be at most {limit_value, number} {limit_value, plural, one {character} other {characters}}",
    },
    "value_error.list.min_items": {
        id: "value_error.list.min_items",
        defaultMessage: "Phone number cannot be empty",
    },
    "value_error.call_group_is_full": {
        id: "value_error.call_group_is_full",
        defaultMessage: "Call group is full",
    },
    "value_error.call_forward_cant_enable": {
        id: "value_error.call_forward_cant_enable",
        defaultMessage: "Required",
    },
    "value_error.call_forward_number_cant_be_empty": {
        id: "value_error.call_forward_number_cant_be_empty",
        defaultMessage: "Required",
    },
    "value_error.device_type_set.global_quota_reached": {
        id: "value_error.device_type_set.global_quota_reached",
        defaultMessage: "Global quota reached for device type set: {device_type_set}",
    },
    "value_error.duplicated": {
        id: "value_error.duplicated",
        defaultMessage: "The value already exists",
    },
    "value_error.email": {
        id: "value_error.email",
        defaultMessage: "Invalid email address",
    },
    "value_error.format": {
        id: "value_error.format",
        defaultMessage: "Invalid format (eg: {example})",
    },
    "value_error.invalid": {
        id: "value_error.invalid",
        defaultMessage: "Invalid",
    },
    "value_error.invalid_audio_input": {
        id: "value_error.invalid_audio_input",
        defaultMessage: "The audio is either invalid or not supported",
    },
    "value_error.invalid_image_input": {
        id: "value_error.invalid_image_input",
        defaultMessage: "The image is either invalid or not supported",
    },
    "value_error.invalid_call_forward_e164": {
        id: "value_error.invalid_call_forward_e164",
        defaultMessage: "Invalid number (E.164, numbers or SIP uris are allowed)",
    },
    "value_error.invalid_e164": {
        id: "value_error.invalid_e164",
        defaultMessage: "Invalid E.164 number (eg +3618781000)",
    },
    "value_error.invalid_mac_address": {
        id: "value_error.invalid_mac_address",
        defaultMessage: "Invalid MAC address",
    },
    "value_error.invalid_path_for_submenu": {
        id: "value_error.invalid_path_for_submenu",
        defaultMessage: "Invalid submenu path: {path}",
    },
    "value_error.invalid_short_number": {
        id: "value_error.invalid_short_number",
        defaultMessage: "Invalid short number",
    },
    "value_error.invalid_color": {
        id: "value_error.invalid_color",
        defaultMessage: "Invalid color. Color must be a valid name or hex code. Example: red, #C10303.",
    },
    "value_error.invalid_user_relocation": {
        id: "value_error.invalid_user_relocation",
        defaultMessage:
            "The location to relocate the user to either is in a different domain or has different country or area code in its pilot number.",
    },
    "value_error.ipv4address": {
        id: "value_error.ipv4address",
        defaultMessage: "Invalid IPV4 address",
    },
    "value_error.name_does_not_exist_for_allocation_type": {
        id: "value_error.name_does_not_exist_for_allocation_type",
        defaultMessage: "The following allocation type does not exist: {name}",
    },
    "value_error.number.not_ge": {
        id: "value_error.number.not_ge",
        defaultMessage: "Too small",
    },
    "value_error.number.not_gt": {
        id: "value_error.number.not_gt",
        defaultMessage: "Must be greater than {limit_value}",
    },
    "value_error.number.not_le": {
        id: "value_error.number.not_le",
        defaultMessage: "Too big",
    },
    "value_error.no_more_linked_devices": {
        id: "value_error.no_more_linked_devices",
        defaultMessage: "The target user does not have any linked devices left.",
    },
    "value_error.not_exists": {
        id: "value_error.not_exists",
        defaultMessage: "Not exists",
    },
    "value_error.not_existent_referrer": {
        id: "value_error.not_existent_referrer",
        defaultMessage: "Referrer does not exist",
    },
    "value_error.not_existent_target": {
        id: "value_error.not_existent_target",
        defaultMessage: "Target does not exist",
    },
    "value_error.missing_retarget": {
        id: "value_error.missing_retarget",
        defaultMessage: "Referrer {referrer} is required to be resolved",
    },
    "value_error.not_a_referrer": {
        id: "value_error.not_a_referrer",
        defaultMessage: "{referrer} does not refer to this endpoint",
    },
    "value_error.pilot_number.area_code_mismatch": {
        id: "value_error.pilot_number.area_code_mismatch",
        defaultMessage: "Since this location has users the area code cannot be changed!",
    },
    "value_error.protected_identifier": {
        id: "value_error.protected_identifier",
        defaultMessage: "This short number is protected.",
    },
    "value_error.required": {
        id: "value_error.required",
        defaultMessage: "Required",
    },
    "value_error.str.regex": {
        id: "value_error.str.regex",
        defaultMessage: "Invalid format",
    },
    "value_error.too_few_lowercase": {
        id: "value_error.too_few_lowercase",
        defaultMessage: "Too few lowercase characters",
    },
    "value_error.too_few_number": {
        id: "value_error.too_few_number",
        defaultMessage: "Too few numbers",
    },
    "value_error.too_few_special_character": {
        id: "value_error.too_few_special_character",
        defaultMessage: "Too few special characters",
    },
    "value_error.too_few_uppercase": {
        id: "value_error.too_few_uppercase",
        defaultMessage: "Too few uppercase characters",
    },
    "value_error.too_long": {
        id: "value_error.too_long",
        defaultMessage: "Too long. Maximum length: {max_length} characters.",
    },
    "value_error.too_short": {
        id: "value_error.too_short",
        defaultMessage: "Too short. Minimum length: {min_length} characters.",
    },
    "value_error.unique": {
        id: "value_error.unique",
        defaultMessage: "Not unique",
    },
    "value_error.unique_additional_email": {
        id: "value_error.unique_additional_email",
        defaultMessage: "This notification email has already been set for another fax.",
    },
    "value_error.user_exists": {
        id: "value_error.user_exists",
        defaultMessage: "An account is already linked to this short number",
    },
    "value_error.domain_quota_reached": {
        id: "value_error.domain_quota_reached",
        defaultMessage: "Domain quota reached",
    },
    "value_error.global_quota_reached": {
        id: "value_error.global_quota_reached",
        defaultMessage: "Global quota reached",
    },
    "value_error.user_package.domain_quota_reached": {
        id: "value_error.user_package.domain_quota_reached",
        defaultMessage: "$extensionLimits.errors.domain_quota_reached",
    },
    "value_error.user_package.global_quota_reached": {
        id: "value_error.user_package.global_quota_reached",
        defaultMessage: "$extensionLimits.errors.global_limit_reached",
    },
    "value_error.quota_exceeded": {
        id: "value_error.quota_exceeded",
        defaultMessage: "Quota exceeded",
    },
    "value_error.not_in_the_allowed_ranges": {
        id: "value_error.not_in_the_allowed_ranges",
        defaultMessage: "E164 is not in the allowed range",
    },
    "value_error.invalid_ftp": {
        id: "value_error.invalid_ftp",
        defaultMessage: "Invalid FTP address. Example: <user>@<host>:<path>, where user and path is optional",
    },
    "value_error.wrong_area_code": {
        id: "value_error.wrong_area_code",
        defaultMessage: "The location pilot number area code not the same as the user E164 area code",
    },
    "value_error.range_end_less_than_start": {
        id: "value_error.range_end_less_than_start",
        defaultMessage: "The end of the range is less than the start",
    },
    "value_error.invalid_domain_name": {
        id: "value_error.invalid_domain_name",
        defaultMessage: "Invalid domain name. Example: example.com",
    },
    "value_error.domain_allocation.below_domain_used": {
        id: "value_error.domain_allocation.below_domain_used",
        defaultMessage: "Input value can not be less than the currently used value",
    },
    "value_error.domain_allocation.exceeds_global_limit": {
        id: "value_error.domain_allocation.exceeds_global_limit",
        defaultMessage: "Input value can not exceed the limit",
    },
    "value_error.domain_allocation.positive": {
        id: "value_error.domain_allocation.negative_value",
        defaultMessage: "Input value must be a positive number",
    },
    "value_error.unknown": {
        id: "value_error.unknown",
        defaultMessage: "Unknown error",
    },
    "value_error.e164_range_intersection": {
        id: "value_error.e164_range_intersection",
        defaultMessage: "The provided E.164 range intersects with another provided range",
    },
    "value_error.e164_range_intersection_other_domain": {
        id: "value_error.e164_range_intersection_other_domain",
        defaultMessage: "The provided E.164 range intersects with an existing range in another domain: {domain}",
    },
    "type_error.none.not_allowed": {
        id: "type_error.none.not_allowed",
        defaultMessage: "Required",
    },
    "bulk_user_modification.errors.authorization": {
        id: "bulk_user_modification.errors.authorization",
        defaultMessage: "You are not authorized to perform this action.",
    },
    "value_error.insufficient_device_limit_excel": {
        id: "value_error.insufficient_device_limit_excel",
        defaultMessage:
            "The selected user package does not provide sufficient device quota for the user's current device types: {device_types}",
    },
    "value_error.invalid_option": {
        id: "value_error.invalid_option",
        defaultMessage: "Invalid option",
    },
});

export default errorMessages;
